import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/constants/routeConstants'

const LogoFooter = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col px-6 pb-4 pt-6 gap-[44px] bg-gradient-orange-fuschia md:px-[50px]">
      <div className="w-full flex flex-col gap-8 md:flex-row md:justify-between md:gap-[45px] ">
        <div className="text-white">
          <img
            src="/img/cleverlink-logo-with-typo-white.svg"
            className="w-24 mb-[11px]"
          ></img>
          <span>{t('footer.tagline')}</span>
        </div>

        <div className="flex flex-col gap-2 text-white md:w-1/4  md:gap-4">
          <span className="font-bold text-lg">{t('footer.contact')}</span>
          <span>{t('footer.email')}</span>
          <span>{t('footer.phone')}</span>
        </div>
      </div>
    </div>
  )
}

const LinkFooter = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-6 px-6 py-4 text-white text-lg bg-black-800 md:flex-row md:gap-8 md:px-[50px]">
      <Link to={`${ROUTES.LEGAL_NOTICES}`} className="hover:font-bold">
        {t('footer.legalNotices')}
      </Link>
      <Link to={`${ROUTES.TERMS_OF_USE}`} className="hover:font-bold">
        {t('footer.termsOfUse')}
      </Link>
      <Link to={`${ROUTES.COOKIE_PREFERENCES}`} className="hover:font-bold">
        {t('footer.cookies')}
      </Link>
      <Link to={`${ROUTES.PERSONAL_DATA}`} className="hover:font-bold">
        {t('footer.privacyPolicy')}
      </Link>
      <Link to={`${ROUTES.CLEVERSCORE}`} className="hover:font-bold">
        {t('footer.cleverScore')}
      </Link>
      <Link to={`${ROUTES.AI_USAGE}`} className="hover:font-bold">
        {t('footer.aiUsage')}
      </Link>
    </div>
  )
}

const RightsFooter = () => {
  const { t } = useTranslation()
  const date = new Date()
  return (
    <div className="flex py-2.5 px-6 md:justify-center md:items-center bg-black-800 border-t border-t-white text-white text-sm md:px-[50px]">
      {t('footer.copyright', { year: date.getFullYear() })}
    </div>
  )
}

export const Footer = () => {
  return (
    <footer>
      <LogoFooter />
      <LinkFooter />
      <RightsFooter />
    </footer>
  )
}
